import { render, staticRenderFns } from "./NewSDS.vue?vue&type=template&id=05198779&scoped=true&"
import script from "./NewSDS.vue?vue&type=script&lang=js&"
export * from "./NewSDS.vue?vue&type=script&lang=js&"
import style0 from "./NewSDS.vue?vue&type=style&index=0&id=05198779&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05198779",
  null
  
)

export default component.exports